<script setup>
import {onMounted, ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue'
import {useRoute} from 'vue-router';
import identificationService from '@/services/IdentificationService';
import FileListComponent from '@/components/file-list/FileListComponent.vue';
import {allowedBankID} from '@/helper';
import {useI18n} from 'vue-i18n';
import AppAnnouncements from '@/components/AppAnnouncements.vue';

const {t} = useI18n()
const props = defineProps({
  identification: {type: Object, required: false},
  disabled: {type: Boolean, required: false, default: false},
});

const params = useRoute().params;
const selectedMethod = ref(null);
const attachments = ref(null);
const form = ref({...props.identification});
const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);
const availableMethods = [
  {label: t('identificationModal.method_personal_id'), value: 'IDCARD'},
  {label: t('identificationModal.method_driver_licence'), value: 'DRIVER_LICENSE'},
  {label: t('identificationModal.method_passport'), value: 'PASSPORT'},
  {label: t('identificationModal.method_birth_certificate'), value: 'BIRTH_CERTIFICATE'},
  // Musí odpovídat BE IdentificationMethodEnum - povolení k pobytu může klient nahrát i v onboardingu
  {label: t('identificationModal.method_residence_permit'), value: 'RESIDENCE_PERMIT'},
];
const closeModalWith = (value, state) => {
  setTimeout(() => {
    isOpen.value = false;
    if (value === 'confirm') {
      form.value.state = state
      form.value.method = selectedMethod.value;
      if (!state) {
        form.value.state = 'WAITING';
      }
      emit('confirm', form.value);
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}
emitter.on('close-modal', () => {
  isOpen.value = false;
});
onMounted(() => {
  selectedMethod.value = 'IDCARD';
  if (allowedBankID()) {
    availableMethods.push({label: 'Bank ID', value: 'BANKID'});
  }
  if (props.identification?.id && props.identification.method !== 'BANKID') {
    identificationService.get(params.id, props.identification.id).then((response) => {
      attachments.value = response.attachments;
    });
  }
})
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('identificationModal.identification') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
            <form @submit.prevent="closeModalWith('confirm')" id="identificationForm">
              <div class="modal-body">
                <!-- IMA-519: upozornění na odstávku Bank iD jen při zakládání (volbě metody) identifikace -->
                <AppAnnouncements v-if="!form.id" :onlyBankId="true"/>
                <div class="row mb-3">
                  <div v-if="!form.id" class="form-group">
                    <label for="formMethodSelect" class="form-label"> {{ t('identificationModal.choose_method') }}</label>
                    <select id="formMethodSelect" v-model="selectedMethod" class="form-select">
                      <option v-for="method of availableMethods" :value="method.value">{{method.label}}</option>
                    </select>
                  </div>
                </div>
                <div v-if="attachments" class="row mb-3">
                  <div class="col-12">
                    <FileListComponent :files="attachments" :dropzone-disabled="true" :fetch-files="false"/>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button v-if="!identification?.id && !props.disabled" class="btn btn-link text-decoration-underline text-dark" type="button" @click="closeModalWith('cancel')">{{ t('identificationModal.cancel') }}</button>
                <button v-if="!props.disabled" class="btn btn-primary btn-md" type="button" @click="closeModalWith('confirm', 'CONCEPT')">{{ t('identificationModal.save_as_concept') }}</button>
                <button v-if="!props.disabled" class="btn btn-primary btn-md" type="submit">{{ t('identificationModal.save_and_send_to_client') }}</button>
              </div>
            </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

